/**
 * RIM constants — plan-number prefix map, beneficiary-design id codes,
 * contribution / RMD references.  Sourced from modules digest §RIM.
 */

export const IRA_PLAN_TYPES = [
  { code: 'TRAD',       prefix: '10000', label: 'Traditional' },
  { code: 'ROTH',       prefix: '20000', label: 'Roth' },
  { code: 'COVERDELL',  prefix: '30000', label: 'Coverdell ESA' },
  { code: 'SEP',        prefix: '40000', label: 'SEP' },
  { code: 'INHERITED',  prefix: '50000', label: 'Inherited' },
  { code: 'SIMPLE',     prefix: '60000', label: 'SIMPLE' },
] as const;

export type IraPlanCode = (typeof IRA_PLAN_TYPES)[number]['code'];

/**
 * BenfDesigId per TaxPlnBenfAdd (1 = Primary, 2 = Contingent).
 */
export const BENF_DESIG = {
  primary: 1,
  contingent: 2,
} as const;

/**
 * Transaction codes used on IRA deposits / withdrawals.
 * 612 Regular, 614 Direct Rollover, 619 Prior Year, 632 Transfer, 663 SEP Employer,
 * 631 Normal W/D, 633 Transfer Out, 641/651 Early W/D, 654 Death Distribution,
 * 638 Fed W/H, 665 State W/H.
 */
export const IRA_TXN_CODES: ReadonlyArray<{ code: string; label: string; kind: 'deposit' | 'withdrawal' | 'withholding' }> = [
  { code: '612', label: 'Regular contribution', kind: 'deposit' },
  { code: '614', label: 'Direct rollover',      kind: 'deposit' },
  { code: '619', label: 'Prior year',           kind: 'deposit' },
  { code: '632', label: 'Transfer in',          kind: 'deposit' },
  { code: '663', label: 'SEP employer',         kind: 'deposit' },
  { code: '631', label: 'Normal W/D',           kind: 'withdrawal' },
  { code: '633', label: 'Transfer out',         kind: 'withdrawal' },
  { code: '641', label: 'Early W/D',            kind: 'withdrawal' },
  { code: '651', label: 'Early W/D (code 651)', kind: 'withdrawal' },
  { code: '654', label: 'Death distribution',   kind: 'withdrawal' },
  { code: '638', label: 'Federal W/H',          kind: 'withholding' },
  { code: '665', label: 'State W/H',            kind: 'withholding' },
];

/**
 * Validation boundaries — client-side cap per Field 279 Beneficiary Percent.
 */
export const BENEFICIARY_PERCENT_MIN = 0;
export const BENEFICIARY_PERCENT_MAX = 100;
